/**
 * Embed mode mapping for events from HSDK
 * @author Nachiket Kakatkar <nachiket@helpshift.com>
 * @created Feb 23, 2023
 * @module constants/embedModeEvents
 */

import hsdkMsgTypes from "constants/hsdkMessageTypes";

/**
 * Only events mapped here would be handled by the dashboard
 * in embed mode. This prevents against random events being posted
 * on the iframe
 */
export default {
  [hsdkMsgTypes.OPEN_ISSUE]: "openIssue"
};
